import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
// import { isMobile } from 'react-device-detect';

function KishPortInfo() {
  const list = [1, 2, 3];
  return (
    <Row className="pb-5 mb-5 px-2 mx-0 " style={{ overflowX: "hidden" }}>
      {list.map((item, key) => {
        return (
          <SkeletonTheme key={key}>
            <Col
              xs={12}
              md={4}
              lg={4}
              xl={4}
              style={{ borderRadius: "10px" }}
              className="shadow-sm px-2  my-2  pb-2"
            >
              <div>
                <Col
                  xs={12}
                  lg={10}
                  xl={12}
                  className="px-xl-3 px-0 mx-lg-auto"
                >
                  <Skeleton height="150px" width="100%"></Skeleton>
                </Col>
              </div>
            </Col>
          </SkeletonTheme>
        );
      })}
    </Row>
  );
}
export default KishPortInfo;
